import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Table} from 'antd';
import { TableCard, } from 'components';
import { includes, number as lNumber } from 'libs';
import store from './store';
import { Action } from 'components';
import moment from "moment";
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const [rowrecords, setrowRecords] = useState({});
  const [isdisabled, setDisabled] = useState(true);
  const [data, setData] = useState([]);
  const {t, i18n} = useTranslation();

  useEffect(()=>{
    setData(store.records)
    console.log(store.records);
  },[store.records])


  const columns = [{
    title: t('项目号'),
    dataIndex: 'projectNo',
  }, {
    title: t('负责人'),
    dataIndex: 'manageUserName',
  }, {
    title: t('申请人'),
    dataIndex: 'applyUserName',
  }, {
    title: t('邮箱'),
    dataIndex: 'applyEmail',
  }, {
    title: t('手机号'),
    dataIndex: 'applyPhone',
  }, {
    title: t('使用状态'),
    dataIndex: 'status',
    render: info => info===1?'启用':'禁用'
  }, {
    title: t('项目组成员'),
    dataIndex: 'projectUserList',
    render: info=>{
      let userList = null;
      if (info.length) {
        userList = info.map(item=>{
          return item.userName;
        })
        userList = userList.join();
      }
      return userList;
    }
  },]
  

  return (
    <Table
      rowKey="id"
      loading={store.fetching}
      dataSource={data}
      bordered
      scroll={{ x: 100, }}
      columns={columns}
      pagination={{
        showSizeChanger: true,
        showLessItems: true,
        current: store.page,
        pageSize: store.pageSize,
        total: store.pageTotal,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: store.pageChange
      }}
      onReload={store.fetchRecords}
    />
  )

})
